import axios from "axios";
import { handleError, handleSuccess } from "../../helpers/handleToast";

const API_URL = process.env.REACT_APP_API;

export const getUser = async (user, setIsLoadUserId, setUndefinedUserId) => {
  try {
    const userData = await axios
      .post(`${API_URL}/user`, {
        id: user?.id,
      })
      .then((response) => response.data)
      .then(async (data) => {
        if (data !== null) {
          await setIsLoadUserId(true);
          await getAction();
        } else {
          await setUndefinedUserId(true);
        }
        return data;
      });
    // handleSuccess();
    return userData;
  } catch (error) {
    if (error.response) {
      // handleError(
      //   new Error(`Ошибка сервера: ${error.response.status} ${error.response.statusText}`)
      // );
    } else if (error.request) {
      // handleError(new Error("Сервер не отвечает"));
    } else {
      // handleError(new Error(error.message));
    }
  }
};

export const getYandexUsersArray = async () => {
  try {
    const yandexUsers = await axios
      .post(`${API_URL}/yandex/users`)
      .then((response) => response.data);

    return yandexUsers;
  } catch (error) {
    handleError(error);
  }
};

export const addYandexUsers = async (user) => {
  try {
    await axios.post(`${API_URL}/yandex/add/user`, {
      user,
    });
  } catch (error) {
    handleError(error);
  }
};

export const getDataService = async (setMarkers, setArchive) => {
  try {
    await axios
      .post(`${API_URL}/documents`)
      .then((response) => response.data)
      .then(async (data) => {
        if (data !== null) {
          const fullCollections = data.filter((item) => item.status === "active");
          const archiveCollection = data.filter((item) => item.status === "archive");

          await setArchive(archiveCollection);
          await setMarkers(fullCollections);
        }
      });
  } catch (error) {
    handleError(error);
  }
};

export const setDataService = async (
  user,
  valueDatePicker,
  selectedMarker,
  setOpenModal,
  setSelectedMarker,
  setMarkers,
  setArchive,
) => {
  const dateObj = new Date(valueDatePicker);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();
  const year = dateObj.getFullYear();

  try {
    await axios.post(`${API_URL}/add/service`, {
      data: selectedMarker,
      date: `${day}.${month}.${year}`,
      id: user?.id,
    });
    setOpenModal(false);
    setSelectedMarker(null);
    await getDataService(setMarkers, setArchive);
    await getAction();
  } catch (error) {
    handleError(error);
  }
};

export const setComment = async (user, selectedMarker, setMarkers, valueComment, setArchive) => {
  try {
    await axios
      .post(`${API_URL}/comment`, {
        data: selectedMarker,
        id: user?.id,
        value: valueComment,
      })
      .then((response) => response.data)
      .then(async (data) => {
        await getDataService(setMarkers, setArchive);
        await getAction();
      });
  } catch (error) {
    handleError(error);
  }
};

export const setInfo = async (user, selectedMarker, setMarkers, value, setArchive) => {
  try {
    await axios
      .post(`${API_URL}/info`, {
        value: value,
        data: selectedMarker,
        id: user?.id,
      })
      .then((response) => response.data)
      .then(async (data) => {
        await getDataService(setMarkers, setArchive);
        await getAction();
      });
  } catch (error) {
    handleError(error);
  }
};

export const changeRepair = async (user, selectedMarker, setMarkers, setArchive) => {
  try {
    await axios
      .post(`${API_URL}/repair`, {
        data: selectedMarker,
        id: user?.id,
      })
      .then((response) => response.data)
      .then(async (data) => {
        await getDataService(setMarkers, setArchive);
        await getAction();
      });
  } catch (error) {
    handleError(error);
  }
};

export const getAction = async () => {
  try {
    const action = await axios
      .post(`${API_URL}/action`)
      .then((response) => response.data)
      .then(async (data) => {
        return data;
      });
    return action;
  } catch (error) {
    handleError(error);
  }
};

export const setChangeSystem = async (user, selectedMarker, setMarkers, value, setArchive) => {
  try {
    await axios
      .post(`${API_URL}/change/system`, {
        data: selectedMarker,
        value: value,
        id: user?.id,
      })
      .then((response) => response.data)
      .then(async (data) => {
        await getDataService(setMarkers, setArchive);
        await getAction();
      });
  } catch (error) {
    handleError(error);
  }
};

// handle Faults controller

export const getFetchFaults = async (setFetchFaults) => {
  try {
    await axios
      .post(`${API_URL}/faults`)
      .then((response) => response.data)
      .then(async (data) => {
        await setFetchFaults(data);
      });
  } catch (error) {
    handleError(error);
  }
};

export const setChangeFaults = async (
  user,
  selectedMarker,
  addedFaults,
  removedFaults,
  setFetchFaults,
) => {
  try {
    await axios
      .post(`${API_URL}/faults/change`, {
        user,
        data: selectedMarker,
        addedFaults,
        removedFaults,
      })
      .then((response) => response.data)
      .then(async (data) => {
        await setFetchFaults(data);
      });
  } catch (error) {
    handleError(error);
  }
};

// handle File controller
export const getFetchPdf = async (setFetchPdf) => {
  try {
    await axios
      .post(`${API_URL}/get/pdf`)
      .then((response) => response.data)
      .then(async (data) => {
        setFetchPdf(data);
      });
  } catch (error) {
    handleError(error);
  }
};

export const setPdfFile = async (formData, setFetchPdf) => {
  try {
    await axios
      .post(`${API_URL}/upload-pdf`, formData)
      .then((response) => response.data)
      .then(async (data) => {
        await setFetchPdf(data);
      });
  } catch (error) {
    handleError(error);
  }
};

export const setFile = async (formData, setFetchPdf) => {
  try {
    await axios
      .post(`${API_URL}/upload-file`, formData)
      .then((response) => response.data)
      .then(async (data) => {
        await setFetchPdf(data);
      });
  } catch (error) {
    handleError(error);
  }
};

export const getLinkFile = async (user, item, publicUrl) => {
  try {
    const encodedUrl = encodeURIComponent(publicUrl);
    const proxyLink = `${API_URL}/proxy-download?publicUrl=${encodedUrl}`;

    const link = document.createElement("a");
    link.href = proxyLink;
    link.download = item.value;
    link.target = "_blank";
    link.rel = "noopener noreferrer";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    handleError(error);
  }
};

export const deleteFile = async (user, fileName, marker, setFetchPdf) => {
  try {
    await axios
      .post(`${API_URL}/delete-file`, {
        user,
        fileName,
        marker,
      })
      .then((response) => response.data)
      .then(async (data) => {
        setFetchPdf(data);
      });
  } catch (error) {
    handleError(error);
  }
};

// handle Orders controller

export const getOrdersCurrent = async (setOrdersCurrent) => {
  try {
    await axios
      .post(`${API_URL}/orders/current`)
      .then((response) => response.data)
      .then(async (data) => {
        await setOrdersCurrent(data);
      });
  } catch (error) {
    handleError(error);
  }
};

export const getOrdersResolved = async (setOrdersResolved) => {
  try {
    await axios
      .post(`${API_URL}/orders/resolved`)
      .then((response) => response.data)
      .then(async (data) => {
        await setOrdersResolved(data);
      });
  } catch (error) {
    handleError(error);
  }
};
